import { isValidDate } from "@tellescope/utils";

interface DateCellProps {
  timestamp?: number | string | Date;
}

/**
 * Formats timestamps to readable dates
 * Handles various date formats (number, string, Date object)
 */
export function DateCell({ timestamp }: DateCellProps) {
  if (!timestamp) return <span className="text-muted-foreground">—</span>;

  let date: Date;

  if (typeof timestamp === "number") {
    date = new Date(timestamp);
  } else if (typeof timestamp === "string") {
    date = new Date(timestamp);
  } else {
    date = timestamp;
  }

  if (!isValidDate(date)) {
    return <span className="text-muted-foreground">—</span>;
  }

  return (
    <div className="flex flex-col">
      <span className="text-foreground font-medium">{date.toLocaleDateString()}</span>
      <span className="text-muted-foreground text-xs">
        {date.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })}
      </span>
    </div>
  );
}
